import { AbsenceId } from 'types';

export const ABSENCES = `/api/v1/absences`;
export const ABSENCE = (absenceId: AbsenceId) => `/api/v1/absences/${absenceId}`;
